var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPanel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "92px",
    viewBox: "0 0 92 92",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5 0C41.5433 0 43.5681 0.154203 45.5621 0.459178C47.1022 0.694721 48.1582 2.12464 47.9209 3.65299C47.6835 5.18135 46.2427 6.22938 44.7026 5.99384C42.9928 5.73232 41.2553 5.6 39.5 5.6C21.9519 5.6 7.52191 18.8487 5.81236 35.8167L5.75854 36.4L73.2386 36.4L73.2303 36.277C72.4452 27.262 68.0523 19.0428 61.0957 13.3211L60.3406 12.7177C59.1132 11.765 58.8965 10.0052 59.8565 8.78719C60.8166 7.56914 62.5898 7.35406 63.8172 8.3068C73.3284 15.6899 79 26.9833 79 39.2C79 40.6359 77.9108 41.8194 76.5076 41.9812L76.1786 42L2.82143 42C1.2632 42 0 40.7464 0 39.2C0 17.5504 17.6848 0 39.5 0Z",
    transform: "translate(5 25)",
    id: "Path",
    fill: "#07A5DF",
    stroke: "none",
    className: "fill-primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6028 1.64118C12.269 0.213481 13.9568 -0.399249 15.3726 0.27261C16.6872 0.896479 17.305 2.40861 16.8531 3.76454L16.7297 4.0742L5.39723 28.3588C4.73099 29.7865 3.0432 30.3992 1.62745 29.7274C0.31282 29.1035 -0.304985 27.5914 0.146891 26.2355L0.270329 25.9258L11.6028 1.64118Z",
    transform: "translate(42 35)",
    id: "Path-11",
    fill: "#0B67B2",
    stroke: "none",
    className: "fill-secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 8C17 3.58172 13.1944 0 8.5 0C3.80558 0 0 3.58172 0 8",
    transform: "matrix(-1 0 0 1 53 54)",
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11C8.53757 11 11 8.53757 11 5.5C11 2.46243 8.53757 0 5.5 0C2.46243 0 0 2.46243 0 5.5C0 8.53757 2.46243 11 5.5 11Z",
    transform: "matrix(-1 0 0 1 50 56)",
    id: "Oval",
    fill: "#07A5DF",
    fillRule: "evenodd",
    stroke: "none",
    className: "fill-primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.805456 0.805456C1.79679 -0.185875 3.35667 -0.262131 4.43547 0.576688L4.69454 0.805456L10.1945 6.30546C11.2685 7.3794 11.2685 9.1206 10.1945 10.1945C9.20321 11.1859 7.64333 11.2621 6.56453 10.4233L6.30546 10.1945L0.805456 4.69454C-0.268485 3.6206 -0.268485 1.8794 0.805456 0.805456Z",
    transform: "translate(25 31)",
    id: "Path-12",
    fill: "#07A5DF",
    stroke: "none",
    className: "fill-secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.823762 0.823762C1.83762 -0.190099 3.43296 -0.268088 4.53628 0.589794L4.80124 0.823762L10.4262 6.44876C11.5246 7.54711 11.5246 9.32789 10.4262 10.4262C9.41238 11.4401 7.81704 11.5181 6.71372 10.6602L6.44876 10.4262L0.823762 4.80124C-0.274587 3.70289 -0.274587 1.92211 0.823762 0.823762Z",
    transform: "matrix(-0.9238795 -0.38268346 -0.38268346 0.9238795 80.47442 47.580772)",
    id: "Path-12-Copy",
    fill: "#07A5DF",
    stroke: "none",
    className: "fill-secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.823762 0.823762C1.83762 -0.190099 3.43296 -0.268088 4.53628 0.589794L4.80124 0.823762L10.4262 6.44876C11.5246 7.54711 11.5246 9.32789 10.4262 10.4262C9.41238 11.4401 7.81704 11.5181 6.71372 10.6602L6.44876 10.4262L0.823762 4.80124C-0.274587 3.70289 -0.274587 1.92211 0.823762 0.823762Z",
    transform: "matrix(0.9238795 -0.38268346 0.38268346 0.9238795 9.525583 47.580772)",
    id: "Path-12-Copy-2",
    fill: "#07A5DF",
    stroke: "none",
    className: "fill-secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z",
    transform: "translate(56 28)",
    id: "Oval",
    fill: "#0B67B2",
    fillRule: "evenodd",
    stroke: "none",
    className: "fill-secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L90 0L90 90L0 90L0 0Z",
    id: "Rectangle",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanel);
export default __webpack_public_path__ + "static/media/panel.46f651ca08426061dc373a1c404632f3.svg";
export { ForwardRef as ReactComponent };